/**
 * Asynchronously loads the component for TestAdditionalInfoPopup page
 */

import { lazyLoad } from 'utils/loadable';

export const TestAdditionalInfoPopup = lazyLoad(
  () => import('./index'),
  module => module.TestAdditionalInfoPopup
);
